// extracted by mini-css-extract-plugin
export default {"header":"buRw0feP","brand":"U3MrK4Zr","brandIcon":"RYkLn_I5","navLink":"LTBsGRNJ","tagline":"wD4GnRtO"};